// Somebody signed in without a Platform role has nothing to see on the
// Platform: a person of another product only — a Voice Recorder talent in a
// company, or somebody who signed up for TTS and is in no company. The API
// answers 403 with this code — not 401: their login is fine, and a redirect to
// the login page would only send them round in a circle while the shared SSO
// cookie is still valid.
export const NO_PLATFORM_ACCESS_CODE = 'NO_PLATFORM_ACCESS';

export const NO_PLATFORM_ACCESS_PATH = '/no-access';

// Whether a failed API call says the person has no access to the Platform.
export const isNoPlatformAccess = (error: any): boolean =>
    error?.response?.status === 403 && error?.response?.data?.code === NO_PLATFORM_ACCESS_CODE;

// Sends the person to the no-access page in place of the page they asked for.
// Replacing, not pushing: Back would open that page again, its request would
// answer the same 403, and the browser would land here once more — Back could
// never leave.
export const showNoPlatformAccess = (navigate: (path: string, options: { replace: boolean }) => void): void => {
    navigate(NO_PLATFORM_ACCESS_PATH, { replace: true });
};
